var _path, _path2, _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChainListIcon1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 112,
    viewBox: "0 0 99 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7159 8.25213C36.6209 -5.22951 64.8632 3.26477 82.7966 27.2247C100.73 51.184 101.564 81.5361 84.6589 95.0181C67.7538 108.499 39.5116 100.005 21.578 76.0456C3.64443 52.0858 2.8108 21.7337 19.7159 8.25213Z",
    fill: "#DAF727"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5295 15.8584C22.2996 8.8642 33.9492 7.62503 45.5959 11.1279C57.2408 14.6303 68.9559 22.8847 78.0344 35.0137C87.1132 47.1433 91.8855 60.9177 92.2287 73.4111C92.5718 85.8999 88.4827 97.2002 79.7199 104.188C70.9499 111.182 59.3003 112.421 47.6535 108.918C36.0086 105.416 24.2936 97.1622 15.2151 85.0332C6.13616 72.9035 1.36293 59.1283 1.01974 46.6348C0.676806 34.1462 4.76678 22.8464 13.5295 15.8584Z",
    fill: "#5235E8",
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_144",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 29,
    width: 56,
    height: 63
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 51,
    transform: "translate(18.4783 43.9756) rotate(-21.6136)",
    fill: "url(#pattern0_1_144)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_144)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.4783,
    y: 43.9756,
    width: 39,
    height: 51,
    transform: "rotate(-21.6136 18.4783 43.9756)",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1_144",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_144",
    transform: "scale(0.025641 0.0196078)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_144",
    width: 39,
    height: 51,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAzCAMAAAAjOuGKAAAA51BMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACWqgEeAAAATXRSTlMA/wPU/k71AYH7BPntFEU0Y6MWBgmYx+JwwtiNypy5XvMR2lwhrYjrL5+QGTiUHYQxJAvOd7w7zWrw5dJ8SbBudMRMtFEOJ0FULN7oVy+Ax+MAAAJnSURBVHichZXXeuIwEIUlE9N7SSD0GjokBEgIddOzef/n2RmhMrbxt+ciVkY/smZ8RmIOLcpfo6gzdEmJG86vMrn/cs0453wBg/C+mHrw5yzAeBcGGXje3PtyKeRmkou5ufxk+DYVo88YzIdhsMAfeJZ5gd0HqvUOW+H0E0QgH37rSRxnUT/X+HcO+QTguc67sOmdAoX2h7EVxPXcy2XxLQ5heXjVs79mqvh65Wb5emddKEkHX+XSZjbygraXgzKUm25O1BinCosI3eof93pyNgZ2sCd/Dfno5HYyXBF2ib5B8aWw8EZFxYVk4FGDjmyGMnitI2nFvVKuLIMFE6ookHJdGeup9zI2U1yCcLcyhraS6qlSJU0sL7wCMvXK1dR6NlmvJWO1Q+rcSNGjTjhLOPINnk+Zcq+KHjzrhbTU9IIPlIpkuY+GHxUpUH9lZbQRwF6iFE2CsaTaW76Z3JYIO3G2SV3apSH+S7RL2uDBOuV+ZbSkAn1dPVp6tpWxpfls2ge8bbiBDNXIb780qEOW4sp0M0vFHRDZP/VD76qHj5TTb8ZdJ6EId/pIcHRDXUXxrFGGP2tFsJDyLm+BA833RlVtY465/pZQ1Q9xmBBFAoOjPe6n7KGZqYDNwl3SrD46N4P1nc4o21/Wp9l0J+08BqlOtAg5TOjZmdVZwTHlhPNPrFNfu7Af0m6ge3QWdnkYnlfdSlw4K3ja0i7CamGHTGAgDAX7mPZXq7kLwvVwGi8Z3OLG/9ZqI/fL2AN2fOvdn8OmwKbZwDPuizErsQsvITVxGWr7+2uEJ0jm0p3gVCj6nR54Lpl/Vj4q1lckq3EAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChainListIcon1);
export default __webpack_public_path__ + "static/media/chain-list-icon-1.a44010c5f56a97db0fe2876a54306e66.svg";
export { ForwardRef as ReactComponent };